import {
  ActionButtonMenuItem,
  VerticalDotsMenu,
} from "@components/action-buttons/vertical-dots-menu";
import { BaseProjectProps } from "@custom-types/project-types";
import {
  DeleteIcon,
  FaroIconButtonSizes,
  red,
  ArchiveIcon,
  UnarchiveIcon,
  DownloadIcon,
} from "@flat-ui";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { ShareProjectOption } from "@pages/projects/share-project-option";
import { useState } from "react";

/**
 *  Provides actions buttons for project details page in a compact version.
 */
export function ResponsiveProjectButtons({
  project,
}: BaseProjectProps): JSX.Element | null {
  const [shouldShowDeleteDialog, setShouldShowDeleteDialog] =
    useState<boolean>(false);
  const {
    archiveOrUnarchiveProject,
    canDeleteProject,
    archiveActionLabel,
    isProjectActive,
    canDownloadFromVault,
    openInSphereVault,
  } = useProjectActions(project);

  const menuItems: ActionButtonMenuItem[] = [
    {
      label: archiveActionLabel,
      Icon: isProjectActive ? ArchiveIcon : UnarchiveIcon,
      onClick: archiveOrUnarchiveProject,
      isVisible: true,
    },
    {
      label: "Download from Sphere Vault",
      Icon: DownloadIcon,
      onClick: openInSphereVault,
      isVisible: canDownloadFromVault,
    },
    {
      label: "Share",
      component: <ShareProjectOption project={project} />,
      isVisible: true,
    },
    {
      type: "separator",
      isVisible: !isProjectActive && canDeleteProject,
      label: "",
    },
    {
      label: "Delete",
      Icon: DeleteIcon,
      onClick: () => setShouldShowDeleteDialog(true),
      color: red[500],
      highlightColor: red[500],
      isVisible: !isProjectActive && canDeleteProject,
    },
  ];

  return (
    <>
      <VerticalDotsMenu menuItems={menuItems} size={FaroIconButtonSizes.m} />
      {/* Delete Confirmation Dialog */}
      {shouldShowDeleteDialog && (
        <DeleteProject
          project={project}
          onClose={() => setShouldShowDeleteDialog(false)}
        />
      )}
    </>
  );
}
